import {createStyles} from '@material-ui/core'
import { spaces } from 'styles/mixins'

const captionCardStyle = createStyles({
  exampleTypo: {
    marginLeft: spaces.large1,
  },
})

export default captionCardStyle